import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Util } from '../../util';
import { ActionType } from 'src/app/models/action';

@Component({
  selector: 'app-accept-hold-callback',
  templateUrl: './accept-hold-callback.component.html',
  styleUrls: ['./accept-hold-callback.component.scss'],
})
export class AcceptHoldCallbackComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const uuid = params.idr;
      const signature = params.idl;

      if (!uuid || !signature) {
        return this.router.navigate(['/']);
      }

      this.apiService.acceptHoldByMail(uuid, signature).subscribe((response) => {
        const queryParams = {};

        if (response.issueDate) {
          queryParams['issueDate'] = response.issueDate;
        }

        Util.setAction({
          type: ActionType.CHECKOUT,
          recordId: response.recordId,
        });

        this.router.navigate(['/info', response.recordId], {
          queryParams: queryParams,
        });
      });
    });
  }
}
